var discount_direct_base = 'https://discountdirect.shopclimb.com';
var browser = ( detectmob() == true ? 'mobile' : 'pc' );

(function(){
   
    var loadScript = function(url, callback){
        var script = document.createElement("script");
        script.type = "text/javascript";

        // If the browser is Internet Explorer.
        if (script.readyState){
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                  script.onreadystatechange = null;
                  callback();
                }
            };
        // For any other browser.
        } else {
            script.onload = function(){
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var loadStyle = function(url, callback){
        var script = document.createElement("link");
        script.type = "text/css";
        script.rel = "stylesheet";

        // If the browser is Internet Explorer.
        if (script.readyState){ 
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                  script.onreadystatechange = null;
                  callback();
                }
            };
        // For any other browser.
        } else {
            script.onload = function(){
                callback();
            };
        }

        script.href = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    /* This is my app's JavaScript */
    var discountDirectScript = function($){
        $( document ).ready(function( $ ){
            var get = getUrlVars();
            if( get['coupon'] != undefined ) {
                var campaign_id = get['coupon'].split('_');
                campaign_id = campaign_id[0];
                var new_coupon = true;
                
                var discount_direct_data = getCookie('_discount_direct_data');
                if( discount_direct_data != null ) {
                    discount_direct_data = JSON.parse( discount_direct_data );
                    if( discount_direct_data.coupon_id == campaign_id ) new_coupon = false;
                }

                if( new_coupon != false ) {
                    $.get(
                        discount_direct_base + "/coupons.json",
                        {
                            shop: Shopify.shop,
                            id: get['coupon']
                        })
                        .done(function( data ) {
                            var deadline = '';
                            if( parseInt( data.timer ) > 0 ) deadline = add_minutes(new Date(), data.timer).toString();
                            var discount_direct_data = { coupon_id:campaign_id, coupon:data.coupon_code, discount:data.discount, pitch:data.pitch, deadline:deadline, msgRight:data.msg_right, msgBottom:data.msg_bottom, msgStatus:0 };
                            document.cookie = '_discount_direct_data=' + JSON.stringify( discount_direct_data ) + ';domain=.' + current_domain() + ';path=/;';
                            enable_the_coupon();
                        });
                } else enable_the_coupon();
            } else if( is_thank_you_page() && !!order_info() ) {
                let discount_direct_cookie = getCookie('_discount_direct_data');
                const this_order_info = order_info();
                if( !discount_direct_cookie || !this_order_info ) {
                    console.log('No cookie or no order info.');
                    return;
                }

                discount_direct_cookie = JSON.parse( discount_direct_cookie );

                if ( discount_direct_cookie.coupon !== this_order_info.discount_code ) {
                    return;
                }

                const coupon = discount_direct_cookie.coupon_id + '_' + discount_direct_cookie.coupon;
                $.ajax({
                    method: "PATCH",
                    url: discount_direct_base + '/coupons/' + coupon + '/add_order.json',
                    data: {
                        shop: Shopify.shop,
                        order_id: this_order_info.order_id
                    }
                });
            } else enable_the_coupon();
        });

        function enable_the_coupon() {
		    
            var discount_direct_data = getCookie('_discount_direct_data');
            if( discount_direct_data != null ) {
                discount_direct_data = JSON.parse( discount_direct_data );

                var coupon = discount_direct_data.coupon;
                var pitch = discount_direct_data.pitch;
                var discount = discount_direct_data.discount;
                var deadline = discount_direct_data.deadline;
                var msg_status = discount_direct_data.msgStatus;
                var msg_right = ( parseInt( discount_direct_data.msgRight ) > 0 ? parseInt( discount_direct_data.msgRight ) : 4 );
                var msg_bottom = ( parseInt( discount_direct_data.msgBottom ) > 0 ? parseInt( discount_direct_data.msgBottom ) : 10 );

                if( ( deadline == '' ) || ( deadline == 'Invalid Date' ) ) var t = 1;
                else var t = Date.parse(deadline) - Date.parse(new Date()) ;
                if( t > 0 && browser=="mobile" ) {
                    pitch = pitch.replace('[TIMER]', '<span style="font-weight: bold;" id="discount_direct_clockdiv"></span>');
                    pitch = pitch.replace('[DISCOUNT]', '<strong>'+ discount +'</strong>');        
                    pitch = pitch.replace('[COUPON]', '<span style="background-color: #ffe477; color:#706434; font-weight: bold; padding-left: 0.3rem; padding-right: 0.3rem; border-radius: 3px; display: inline-block;">'+ coupon +'</span>');      
                        
                    if( msg_status < 1 ) {
                     var msg_html = '<div class="text-center container-fluid popup" style="positon:fixed;">';
						msg_html+='<div class="coupon_activated_popup text-center container-fluid" style="z-index:2000;background:rgba(255,255,255,.95);max-width:280px;display:inline-block;  border-radius: 3px; box-shadow: 0 1px 6px rgba(0,0,0,.5);right:' + msg_right + 'px;  bottom:' + msg_bottom + 'px;position:fixed;padding: 20px; box-sizing: border-box; text-align: center; font-family: \'HelveticaNeue-Light\', \'Helvetica Neue Light\', \'Helvetica Neue\', Helvetica, Arial, \'Lucida Grande\', sans-serif;">';
						  msg_html += '<div id="discount_direct_cross_btn" style="position: absolute;top: 10px;right: 10px;cursor: pointer;background: url(' + discount_direct_base + '/images/scrappy-10271d4f.png) -172px -137px no-repeat;width: 13px;height: 13px;"></div>';
							  msg_html += '<p class="signin" style="max-width: 350px; text-align: left; margin: 10px 0;font-size: 14px;line-height: 22px;font-weight: 400;color:#788188;font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;" >';
								msg_html += pitch;
							 msg_html += '</p>';
						   msg_html+='</div>';
					     msg_html+='</div>';
						
                        $('body').append( msg_html );
                        $('.coupon_activated_popup').show();
                        $('.coupon_activated_popup').hide();
                        $('.coupon_activated_popup').slideDown(500);
                        if( document.getElementById('discount_direct_clockdiv') != undefined ) countdown( 'discount_direct_clockdiv', deadline );
          
                        document.getElementById("discount_direct_cross_btn").addEventListener( "click", hide_message );
                        document.getElementById('discount_direct_cross_btn').addEventListener( "mouseover", cross_button_over );
                        document.getElementById('discount_direct_cross_btn').addEventListener( "mouseout", cross_button_out );
                    }
                    activate_a_coupon( coupon );
                }
                if( t > 0 && browser=="pc") {
                    pitch = pitch.replace('[TIMER]', '<span style="font-weight: bold;" id="discount_direct_clockdiv"></span>');
                    pitch = pitch.replace('[DISCOUNT]', '<strong>'+ discount +'</strong>');        
                    pitch = pitch.replace('[COUPON]', '<span style="background-color: #ffe477; color:#706434; font-weight: bold; padding-left: 0.3rem; padding-right: 0.3rem; border-radius: 3px; display: inline-block;">'+ coupon +'</span>');      
                        
                    if( msg_status < 1 ) {
                     var msg_html = '<div class="text-center container-fluid popup" style="positon:fixed;">';
						msg_html+='<div class="coupon_activated_popup text-center container-fluid" style="z-index:2000;background:rgba(255,255,255,.95);max-width:320px;display:inline-block;  border-radius: 3px; box-shadow: 0 1px 6px rgba(0,0,0,.5);right:' + msg_right + 'px;  bottom:' + msg_bottom + 'px;position:fixed;padding: 20px; box-sizing: border-box; text-align: center; font-family: \'HelveticaNeue-Light\', \'Helvetica Neue Light\', \'Helvetica Neue\', Helvetica, Arial, \'Lucida Grande\', sans-serif;">';
						  msg_html += '<div id="discount_direct_cross_btn" style="position: absolute;top: 10px;right: 10px;cursor: pointer;background: url(' + discount_direct_base + '/images/scrappy-10271d4f.png) -172px -137px no-repeat;width: 13px;height: 13px;"></div>';
							  msg_html += '<p class="signin" style="max-width: 350px; text-align: left; margin: 10px 0;font-size: 18px;line-height: 24px;font-weight: 400;color:#788188;font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;" >';
								msg_html += pitch;
							 msg_html += '</p>';
						   msg_html+='</div>';
					     msg_html+='</div>';
						
                        $('body').append( msg_html );
                        $('.coupon_activated_popup').show();
                        $('.coupon_activated_popup').hide();
                        $('.coupon_activated_popup').slideDown(500);
                        if( document.getElementById('discount_direct_clockdiv') != undefined ) countdown( 'discount_direct_clockdiv', deadline );
          
                        document.getElementById("discount_direct_cross_btn").addEventListener( "click", hide_message );
                        document.getElementById('discount_direct_cross_btn').addEventListener( "mouseover", cross_button_over );
                        document.getElementById('discount_direct_cross_btn').addEventListener( "mouseout", cross_button_out );
                    }
                    activate_a_coupon( coupon );
                }
            }
        }

        function activate_a_coupon( coupon ) {
            //enable the discount in cart form
            var forms = document.body.getElementsByTagName('form');
            var element;
            if( forms.length > 0 ) {
                for( var i = 0; i < forms.length; i++ ) {
                    if( ( ( forms[i].action.indexOf('/cart') > -1 ) && ( forms[i].action.indexOf('/add') < 0 ) ) || ( forms[i].action.indexOf('/checkout') > -1 ) ) {
                        element = forms[i];
                        if( element.action.indexOf('/checkout') > -1 ) element.action = '/checkout?discount=' + coupon;
                        else element.action = '/cart?discount=' + coupon;
                        element.addEventListener("submit", function() {
                            hide_message();
                        });
                    }
                }
            }

            //Links with href "/checkout"
            var links = document.getElementsByTagName('a');
            if( links.length > 0 ) {
                for( var i = 0; i < links.length; i++ ) {
                    if( links[i].href.indexOf('/checkout') > -1 ) {
                        var element = links[i];
                        element.href = '/checkout/?discount=' + coupon;
                        element.addEventListener("click", function() {
                            hide_message();
                        });
                    }
                }
            }

            //listen to every button/every form for the change
            for( var j = 0; j< document.getElementsByTagName('input').length; j++ ) {
                document.getElementsByTagName('input')[j].addEventListener("change", function() {
                    setInterval( function() { 
                        activate_a_coupon( coupon ); 
                    }, 1500 );
                });
            }

            //listen to every button/every form for the change
            for( var i = 0; i < document.getElementsByTagName('button').length; i++ ) {
                document.getElementsByTagName('button')[i].addEventListener("click", function() {
                    setInterval( function() {
                        activate_a_coupon( coupon );
                    }, 1500 );
                });
            }

            //listen to every button/every form for the change
            for( var i = 0; i < document.getElementsByTagName('a').length; i++ ) {
                document.getElementsByTagName('a')[i].addEventListener("click", function() {
                    setInterval( function() {
                        activate_a_coupon( coupon );
                    }, 1500 );
                });
            }
        }

        function hide_message(){
            var discount_direct_data = getCookie('_discount_direct_data');
            discount_direct_data = JSON.parse( discount_direct_data );
            discount_direct_data.msgStatus = 1;

            document.cookie = '_discount_direct_data=' + JSON.stringify( discount_direct_data ) + ';domain=.' + current_domain() + ';path=/;';
            $('.coupon_activated_popup').show().slideUp(500);
        }

        function cross_button_over() {
            document.getElementById("discount_direct_cross_btn").style.opacity = "1.0";
        }

        function cross_button_out() {
            document.getElementById("discount_direct_cross_btn").style.opacity = "0.5";
        }

        function countdown( id, endtime ) {
            setInterval( function() {
                show_the_clock( id, endtime );
            }, 1000 );
        }

        function current_domain() {
            //trim the url to domain only, to make cookie available to all over the site
            var cookie_domain = window.location.href;
            if( cookie_domain.indexOf('http://' ) > -1 ) cookie_domain = cookie_domain.replace('http://', '');
            if( cookie_domain.indexOf('https://') > -1 ) cookie_domain = cookie_domain.replace('https://', '');
            
            var br = cookie_domain.split('/');
            return cookie_domain = br[0];
        }

        function show_the_clock(id, endtime) {
            var t = Date.parse(endtime) - Date.parse(new Date());
            if( t < 0 ) t = 0;
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = Math.floor(t / (1000 * 60 * 60 * 24));
            
            var clock = '';
            if( days > 0 ) clock += days + ' days ';
            if( hours > 0 ) clock += hours + ' hours ';
            if( minutes > 0 ) clock += minutes + ' minutes ';
            if( seconds > 0 ) clock += seconds + ' seconds ';
            document.getElementById( id ).innerHTML = clock;
        }

        function is_thank_you_page() {
            let pattern = /.+\/.+\/checkouts\/.+\/thank_you/;

            return pattern.test(window.location.href);
        }

        function order_info() {
            const has_order_id = !!Shopify.checkout && Shopify.checkout.order_id;
            const has_discount_code = !!Shopify.checkout && Shopify.checkout.discount.code;

            if (!has_order_id || !has_discount_code) {
                console.log('Missing order id or discount code');

                return null;
            }

            return {
                order_id: Shopify.checkout.order_id,
                discount_code: Shopify.checkout && Shopify.checkout.discount.code
            };
        }
    };

    /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
    we will load jQuery from the Google CDN, and when it's fully loaded, we will run
    our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
    as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {

        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
            jQuery8001 = jQuery.noConflict(true);
            discountDirectScript(jQuery8001);
        });
    } else {
        discountDirectScript(jQuery);
    }

})();

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}

/**
 * Check for mobile device.
 */
function detectmob() {
	if(window.innerWidth <= 600) {
	 return true;
	} else {
	 return false;
	}
}

function getCookie( index ) {
    var value = null;
    var ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        var br = c.split('=');
        if( br[0].trim() == index.trim() ) {
            value = br[1];
            break;
        }
    }
    return value;
}

function getPos(el) {
    // yay readability
    for (var lx=0, ly=0;
         el != null;
         lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
    return {x: lx,y: ly};
}

var add_minutes =  function (dt, minutes) {
    return new Date(dt.getTime() + minutes*60000);
}

